import styled from "styled-components";

interface ImageProps {
  width?: string;
  height?: string;
  mobWidth?: string;
  mobHeight?: string;
}

export const BackgroundContainer = styled.div`
  width: 100%;
  background-color: #FBFBFD;
`

export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 0;
  
  @media(max-width: 768px) {
     padding: 24px 30px;
   }
`

export const Title = styled.div`
  font-size: 36px;
  font-weight: 700;
  line-height: 50px;
  color: #2A2637;
  text-align: center;
  margin-bottom: 36px;
  @media(max-width: 768px) {
     font-size: 24px;
     font-weight: 700;
     line-height: 34px;
     margin-bottom: 32px;
  } 
`

export const SubTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #797199;
  text-align: center;
  
  @media(max-width: 768px) {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
`

export const LesserTitle = styled.div`
  margin-bottom: 48px;
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #2A2637;
  
  @media(max-width: 768px) {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
`

export const GreenText = styled.span`
  color: #01C716;
`

export const Image = styled.img<ImageProps>`
   width: ${({ width }) => width ? width : '800px'};
   height: ${({ height }) => height ? height : '627px'};
   margin-bottom: 36px;
   @media(max-width: 768px) {
     width: ${({ mobWidth }) => mobWidth ? mobWidth : '312px'};
     height: ${({ mobHeight }) => mobHeight ? mobHeight : '244px'};
   }   
`

export const ImageCall = styled.img`
   width: 800px;
   height: 368px;
   margin-top: 48px;
   @media(max-width: 768px) {
     width: 312px;
     height: 143px;
   }   
`

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #2A2637;
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }
`

export const SubText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #797199;
  text-align: center;
`

export const TextComment = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 29px;
  color: #4E4963;
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }
`

export const Indent = styled.div`
  height: 12px;
`

export const TextBold = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  color: #2A2637;
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 28px;
  }  
`

export const BlockQuote = styled.div`
  margin-top: 48px;
`

export const List = styled.ul`
  list-style: none;
  padding-left: 10px;
`;

export const TextList = styled.li`
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #4E4963;
  max-width: 700px;
  &:before {
      content: '•';
      margin-right: 8px; 
  }
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }  
`

export const CallFormWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    display: block;
  }
`

export const CallBlock = styled.div`
  max-width: 470px;
  display: flex;
  position: relative;
  @media (max-width: 768px) {
    display: block;
  }
`
export const CallFormInput = styled.input`
  width: 100%;
  max-width: 260px;
  height: 56px;
  padding: 0 20px;
  font-size: 16px;
  color: #4E4963;
  background: #F7F6F7;
  border: 1px solid transparent;
  border-radius: 8px 0 0 8px;
  transition: border 0.2s;
  &:hover {
    border: 1px solid #E0DDEC;
  }
  &::-webkit-input-placeholder {
    color: #A8A4B9;
  }
  &::-moz-placeholder {
    color: #A8A4B9;
  }
  &:-moz-placeholder {
    color: #A8A4B9
  }
  &:-ms-input-placeholder {
    color: #A8A4B9
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
    margin-bottom: 16px;
    border-radius: 8px;
  }
`

export const ErrorMassage = styled.div`
  background: rgba(42, 38, 55, 0.8);
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  position: absolute;
  color: #FFFFFF;
  left: 0;
  top: 60px;
  @media (max-width: 768px) {
    left: 0;
  }
`

export const CallFormButton = styled.button`
  height: 56px;
  padding: 0 34px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  background: #01C716;
  border-radius: 0 8px 8px 0;
  transition: background 0.2s;
  &:hover {
    background: #00BB20; 
  }
  
  @media (max-width: 768px) {
    width: 100%;
    border-radius: 8px;
  }
`

export const FeatureWrapper = styled.div`
  max-width: 792px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-bottom: 26px;
  &:last-child {
    margin-bottom: 0;
  }
  
  @media (max-width: 768px) {
    display: block;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const Feature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 108px;
  padding: 22px 24px;
  font-size: 18px;
  font-weight: 600;
  line-height: 34px;
  text-align: center;
  border-radius: 12px;
  background-color: ${({ color}) => (color ? color : '#ECF9FC')};
  
  @media (max-width: 768px) {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const QuoteWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 86px;

  @media (max-width: 768px) {
    display: block;  
  }
`

export const QuoteSubWrapper = styled.div`
  padding: 38px 0;
`
